export default defineNuxtRouteMiddleware(async (to, from) => {
})